import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Button, Modal, Header } from 'semantic-ui-react';
import { UserStore, UserDto } from 'stores/users/users-store';
import { connect } from 'redux-scaffolding-ts';
import { Roles } from 'services/identity-service';
import TailwindMultipleUserEditor from 'widgets/bussiness/multiple-selector/multiple-employee-editor-tw';
// import { PositionCodeDto } from 'stores/configuration/profiles/position-codes-store';

interface TailwindChooseUserProps extends WithTranslation {
  onAddUsers?: (users: UserDto[]) => void;
  onCloseUsersModal?: () => void;
  users: UserDto[];
  alreadySelectedUserIds?: string[];
  title?: string;
  acceptBtnTitle?: string;
  usersStore?: UserStore;
  positionCodeId?: string;
  noFilters?: boolean;
  /** If specificLocation is provided, roleLocation should match availables roles*/
  specificLocation?: boolean;
  /** If specificLocation is provided, roleLocation should match availables roles*/
  roleLocation?: Roles;
  showEmployeeIdFilter?: boolean;
  showPositionCodeFilter?: boolean;
  showRoleFilter?: boolean;
  showLocationFilter?: boolean;
}

interface TailwindChooseUserState {
  selectedUsers: UserDto[];
}

@connect(['usersStore', UserStore])
class TailwindChooseUser extends React.Component<TailwindChooseUserProps, TailwindChooseUserState> {
  state: TailwindChooseUserState = {
    selectedUsers: []
  };

  private onCancel = () => {
    this.props.onCloseUsersModal();
  };

  private onAddUsers = () => {
    const { selectedUsers } = this.state;
    if ((selectedUsers || []).length === 0) return;
    if (this.props.onAddUsers) this.props.onAddUsers(selectedUsers);
    this.props.onCloseUsersModal();
  };

  private selectedUsersHandler = (selectedUsers: UserDto[]): void => {
    this.setState({ selectedUsers });
  };

  public render() {
    const { showEmployeeIdFilter, showPositionCodeFilter, showLocationFilter, acceptBtnTitle, ...rest } = this.props;
    const { title, t } = rest;
    const { selectedUsers } = this.state;

    return (
      <Modal
        className="template-search__modal choose-employees"
        open
        closeOnEscape={true}
        onClose={this.onCancel}
        closeOnDimmerClick={false}
      >
        <Modal.Header className="borderless-header">
          <Header as="h2" className="modal-header-title">
            {title ? t(title) : t('Select Users')}
          </Header>
        </Modal.Header>
        <Modal.Content className="modal-content">
          <div className="student-list-table">
            <TailwindMultipleUserEditor
              clearable
              placeholder={t('Employee Name')}
              role="Employee"
              locationIds={[]}
              value={selectedUsers}
              //onChange={users => this.selectedUsers(users)}
              onChange={this.selectedUsersHandler}
            />
          </div>
        </Modal.Content>
        <Modal.Actions>
          {/* <button onClick={this.onCancel} className="bg-white-600 text-blue py-2 px-4 rounded whitespace-nowrap" type="button">
            {t('Cancel')}
          </button>

          <button
            onClick={this.onAddUsers}
            className={`${
              (selectedUsers || []).length === 0 ? 'bg-grey-600' : 'bg-primary-600'
            } text-white py-2 px-4 rounded whitespace-nowrap`}
            type="button"
            disabled={(selectedUsers || []).length === 0}
          >
            {acceptBtnTitle ? t(acceptBtnTitle) : t('Select Users')}
          </button> */}

          <Button className="basic" onClick={this.onCancel}>
            {t('Cancel')}
          </Button>
          <Button className="add-template-button" disabled={(selectedUsers || []).length === 0} onClick={this.onAddUsers} positive>
            {acceptBtnTitle ? t(acceptBtnTitle) : t('Select Users')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation()(TailwindChooseUser);
